import { PDFDocument } from 'pdf-lib';

async function loadPDF(templatePDFPath) {
    try {
        const response = await fetch(templatePDFPath);
        if (!response.ok) {
            throw new Error(`Failed to fetch PDF. Status: ${response.status}`);
        }

        const pdfBytes = await response.arrayBuffer(); // Convert response to ArrayBuffer

        // Log the first 10 bytes to check if it's a valid PDF
        const firstBytes = new Uint8Array(pdfBytes.slice(0, 10));
        console.log('First bytes of the PDF:', firstBytes);

        return PDFDocument.load(pdfBytes); // Load and return the PDF document
    } catch (error) {
        console.error(`Error loading PDF from ${templatePDFPath}:`, error);
        throw error;
    }
}


// Function to collect templates with PDFs
export async function collectTemplatePDFs(templateSettings) {
    // Initialize templates as an empty object
    console.log("templateSettings",templateSettings);
    const templates = {};

    const promises = []; // Initialize an array for promises

    // Iterate through each page size in templateSettings
    for (let [size, sizeSettings] of Object.entries(templateSettings)) {
        if (!sizeSettings) {
            console.warn(`No settings defined for size ${size}.`);
            continue;
        }

        // Initialize templates for the size as an empty object
        templates[size] = templates[size] || {};

        // Iterate through each orientation in the size settings
        for (let [orientation, orientationSettings] of Object.entries(sizeSettings)) {
            if (!orientationSettings) {
                console.warn(`No settings defined for size ${size} and orientation ${orientation}.`);
                continue;
            }

            // Initialize templates for the orientation as an empty object
            templates[size][orientation] = templates[size][orientation] || {};

            // Iterate through each linguistic regime in the orientation settings
            for (let [linguisticRegime, linguisticRegimeSettings] of Object.entries(orientationSettings)) {
                if (!linguisticRegimeSettings) {
                    console.warn(`No settings defined for size ${size}, orientation ${orientation} and linguistic regime ${linguisticRegime}.`);
                    continue;
                }

                // Process each linguistic regime settings
                const promise = (async () => {
                    try {
                        // Load the PDF from the path specified in templatePDFPath
                        console.log("linguisticRegimeSettings.templatePDFPath",linguisticRegimeSettings.templatePDFPath);
                        const templatePDFDoc = await loadPDF(linguisticRegimeSettings.templatePDFPath);
                        console.log("templatePDFDoc",templatePDFDoc);
                        // Create a new PDF document
                        const newPDFDoc = await PDFDocument.create();
                        const pageCount = templatePDFDoc.getPageCount();
                        const requestedPageIndex = (linguisticRegimeSettings.page ?? 1) - 1;
                        const safePageIndex = requestedPageIndex >= 0 && requestedPageIndex < pageCount
                            ? requestedPageIndex
                            : 0;

                        if (safePageIndex !== requestedPageIndex) {
                            console.warn(
                                `Requested page ${linguisticRegimeSettings.page} is out of range for ${linguisticRegimeSettings.templatePDFPath} (${pageCount} page(s)). Falling back to page 1.`
                            );
                        }
                        
                        // Copy the specific page from the loaded PDF and add it to the new document
                        const [page] = await newPDFDoc.copyPages(templatePDFDoc, [safePageIndex]);
                        newPDFDoc.addPage(page);

                        // Update the settings with the loaded PDF
                        templates[size][orientation][linguisticRegime] = {
                            ...linguisticRegimeSettings,
                            templatePDF: newPDFDoc, // Attach the loaded PDF document
                        };
                    } catch (error) {
                        console.error(`Error loading PDF for ${size}, ${orientation}, ${linguisticRegime}:`, error);
                    }
                })();

                promises.push(promise); // Add the promise to the list of promises
            }
        }
    }

    // Wait for all PDF loading promises to resolve
    await Promise.all(promises);

    return templates; // Return the updated template settings
}
